import Text from '@src/components/Text';
import dayjs from 'dayjs';

import { CreateFamilyEvent } from '../../type';
import * as S from './styled';

const WeddingPreview = ({
  formData,
  title: _title,
}: {
  formData: CreateFamilyEvent;
  title: string;
}) => {
  const { date, address, detailAddress, contacts, remarks, paymentAccount } = formData;

  const title = _title.replace('[결혼] ', '');

  return (
    <>
      <Text size={16} weight={500} style={{ marginBottom: 8 }}>
        홈페이지 & 메일
      </Text>
      <S.Container>
        <div
          dangerouslySetInnerHTML={{
            __html: `&nbsp;
<table align="center" bgcolor="#f0f0f0" cellpadding="0" cellspacing="0" class=" cke_show_border" style="border-collapse: collapse; color: rgb(85, 85, 85); font-family: 나눔고딕, NanumGothic, 맑은고딕, &quot;Malgun Gothic&quot;, dotum, 돋움, Dotum, Helvetica, AppleSDGothicNeo-Regular; font-size: 12px; line-height: 22px; width: 600px;">
    <tbody>
        <tr>
            <td align="center" class="header" valign="top" style="margin: 0px; padding: 0px; font-size: 16px; font-family: &quot;맑은 고딕&quot;, &quot;Malgun Gothic&quot;, dotum, sans-serif; color: rgb(0, 0, 0); word-break: break-all; line-height: 22px; height: 0px;">
            <table align="center" bgcolor="#f0f0f0" cellpadding="0" cellspacing="0" class=" cke_show_border" style="border-collapse: collapse; line-height: 22px; width: 600px;">
                <tbody>
                    <tr>
                        <td width="360" style="margin: 0px; padding: 0px; font-size: 16px; font-family: &quot;맑은 고딕&quot;, &quot;Malgun Gothic&quot;, dotum, sans-serif; word-break: break-all; line-height: 22px; height: 0px;"><span style="font-size: 24px; font-family: 나눔고딕, NanumGothic, 맑은고딕, &quot;Malgun Gothic&quot;, dotum, 돋움, Dotum, Helvetica, AppleSDGothicNeo-Regular;">&nbsp;&nbsp;&nbsp;<b>祝 結婚</b></span></td>
                        <td width="20" style="margin: 0px; padding: 0px; font-size: 16px; font-family: &quot;맑은 고딕&quot;, &quot;Malgun Gothic&quot;, dotum, sans-serif; word-break: break-all; line-height: 22px; height: 0px;">&nbsp;</td>
                        <td class="ourwebsite" idth="260" style="margin: 0px; padding: 0px; font-size: 16px; font-family: &quot;맑은 고딕&quot;, &quot;Malgun Gothic&quot;, dotum, sans-serif; word-break: break-all; line-height: 16px; text-align: center; height: 0px;"><img alt="" data-cke-saved-src="https://userimg-mkt.tason.com/20210616/ekcplaa_3bd8c90bd50fd996e4ca0ee9bf00f3fa.png" src="https://userimg-mkt.tason.com/20210616/ekcplaa_3bd8c90bd50fd996e4ca0ee9bf00f3fa.png" style="border: 0px solid; cursor: default; height: 52px; width: 200px;" /></td>
                    </tr>
                </tbody>
            </table>
            </td>
        </tr>
        <tr>
            <td class="content" id="iframe_module_content" style="margin: 0px; padding: 0px; font-size: 16px; font-family: &quot;맑은 고딕&quot;, &quot;Malgun Gothic&quot;, dotum, sans-serif; color: rgb(0, 0, 0); word-break: break-all; line-height: 22px; text-align: center; vertical-align: top; background-color: rgb(255, 255, 255); height: 0px;">
            <table align="center" cellpadding="0" cellspacing="0" class=" cke_show_border" style="border-collapse: collapse; line-height: 22px; width: 540px;">
                <tbody>
                    <tr>
                        <td style="margin: 0px; padding: 0px; font-size: 16px; font-family: &quot;맑은 고딕&quot;, &quot;Malgun Gothic&quot;, dotum, sans-serif; word-break: break-all; line-height: 22px; text-align: center; vertical-align: top; height: 0px;">
                        <p style="margin: 0px 0px 12px; padding: 0px; line-height: 22px; font-family: 나눔고딕, NanumGothic, 맑은고딕, &quot;Malgun Gothic&quot;, dotum, 돋움, Dotum, Helvetica, AppleSDGothicNeo-Regular; font-size: 12px;"><br />
                        &nbsp;</p>
                        <h2 style="margin: 0px 0px 10px; padding: 0px; position: relative; font-weight: normal; font-size: 14px; color: rgb(37, 37, 37); line-height: 24px; font-family: 나눔고딕, NanumGothic, 맑은고딕, &quot;Malgun Gothic&quot;, dotum, 돋움, Dotum, Helvetica, AppleSDGothicNeo-Regular;"><span style="font-size: 18px;">${title}</span></h2>
                        <h2 style="margin: 0px 0px 10px; padding: 0px; position: relative; font-weight: normal; font-size: 14px; color: rgb(37, 37, 37); font-family: 나눔고딕, NanumGothic, 맑은고딕, &quot;Malgun Gothic&quot;, dotum, 돋움, Dotum, Helvetica, AppleSDGothicNeo-Regular; line-height: 24px; text-align: left;"><br />
                        <br />
                        &nbsp; &nbsp;&nbsp;◎ 일 시<br />
                        &nbsp; &nbsp; ${dayjs(date)
                          .locale('ko')
                          .format('YYYY년 MMMM D일 dddd, HH:mm')}<br />
                        <br />
                        &nbsp; &nbsp; ◎ 장 소<br />
                        &nbsp; &nbsp; ${detailAddress}<br />
                        &nbsp; &nbsp; ${address}<br />
                        <br />
                        ${
                          contacts.length === 0
                            ? ''
                            : `&nbsp; &nbsp; ◎ 연 락 처<br />
                        ${contacts
                          .map(({ name, phone }) => `&nbsp; &nbsp; ${phone} (${name})<br />`)
                          .join('')}
                        <br />`
                        }
                        ${
                          remarks
                            ? `&nbsp; &nbsp; ◎ 기타<br />${remarks
                                .split('\n')
                                .map(line => (line ? `${line}` : ''))
                                .join('<br/>')}&nbsp;`
                            : ''
                        }
                        </h2>
                        ${
                          paymentAccount &&
                          `<h2 style="margin: 0px 0px 10px; padding: 0px; font-size: 14px; word-break: break-all; overflow-wrap: break-word; font-family: 나눔고딕, NanumGothic, 맑은고딕, &quot;Malgun Gothic&quot;, dotum, 돋움, Dotum, Helvetica, AppleSDGothicNeo-Regular; color: rgb(37, 37, 37); line-height: 24px; text-align: left;">&nbsp; &nbsp; ◎ 마음 전하실 곳<br style="font-size: inherit; word-break: break-all; overflow-wrap: break-word;" />&nbsp; &nbsp; ${paymentAccount}</h2>`
                        }
                        </td>
                    </tr>
                </tbody>
            </table>
            </td>
        </tr>
    </tbody>
</table>`,
          }}
        />
      </S.Container>

      <Text size={16} weight={500} style={{ marginTop: 12, marginBottom: 8 }}>
        메시지
      </Text>
      <S.Container style={{ width: '384px' }}>
        <div style={{ whiteSpace: 'pre-wrap' }}>
          {`
[결혼]
    
${title}

◎ 일    시
  ${dayjs(date).locale('ko').format('YYYY년 MMMM D일 dddd, HH:mm')}
  
◎ 장    소
  ${detailAddress}
  ${address}
${
  contacts && contacts.length
    ? `\n◎ 연 락 처
${contacts
  .map(info => {
    return `  ${info.phone} (${info.name})`;
  })
  .join('\n')}`
    : ''
}
${remarks ? `\n◎ ${remarks}` : ''}
${
  paymentAccount
    ? `\n◎ 마음 전하실 곳
  ${paymentAccount}`
    : ``
}`}
        </div>
      </S.Container>
    </>
  );
};

export default WeddingPreview;
